import React from 'react';
import { StatCardProps } from '../types';

const StatCard: React.FC<StatCardProps> = ({
  number,
  title,
  icon,
  altText,
}) => {
  return (
    <div className="m-3 p-5 shadow-lg rounded-lg w-full">
      <div>
        <h5 className="sm:text-s-20">
          {number} <span className="text-green-250">+</span>
        </h5>
        <p className="sm:text-s-14">{title}</p>
      </div>
      <div className="flex justify-end mt-12">
        <img src={icon} alt={altText} width="44" height="44" loading="lazy" />
      </div>
    </div>
  );
};

export default StatCard;
